import { render } from "./NotFound.vue?vue&type=template&id=a40a78c6&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=a40a78c6&lang=scss&scoped=true"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a40a78c6"]])

export default __exports__